// extracted by mini-css-extract-plugin
export default {"sheduleInterviewDetailsRow":"review_sheduleInterviewDetailsRow__kAYxw","rowSubTitle":"review_rowSubTitle__N+Wek","rowValues":"review_rowValues__+SSK+"};